import "web-ui/styles/fonts.scss";

import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import styles from "./App.module.scss";
import AdminPortal from "./components/GlobalChallengeAdmin/AdminPortal";
import HomePage from "./components/HomePage";
import UnrecoverableErrorPage from "./components/UnrecoverableErrorPage";

const App = () => (
  <div className={styles.app}>
    <ErrorBoundary fallback={<UnrecoverableErrorPage />}>
      <BrowserRouter>
        <Routes>
          <Route element={<HomePage />} path="/" />
          <Route element={<AdminPortal />} path="/global-challenge" />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </div>
);

export default App;
